import gql from 'graphql-tag';

export const customQueueFragment = gql`
  fragment customQueueParts on CustomQueue {
    id
    partnerPersonContextId
    name
    priority
    enabled
    eventTypes
    attendanceTeamIds
  }
`;

export const myCustomQueueFragment = gql`
  fragment myCustomQueueParts on MyCustomQueue {
    id
    name
    eventTypes
  }
`;
